(function ($) {
  $(window).on("load resize orientationchange", function () {
    setTimeout(function () {
      $(".col-two-video").css("opacity", "1");
    }, 500);
    if ($(".col-two-video").length > 0) {
      $(".col-two-video").each(function () {
        if ($(" .col-two-video .two-col").length > 2) {
          $(" .col-two-video .row-wrap")
            .not(".slick-initialized")
            .slick({
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
              infinite: false,
              cssEase: "linear",
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            });
        }
      });
        $(".col-two-video .text-wrap h6").dotdotdot({
            height: 80,
            fallbackToLetter: true,
            watch: true,
        });


    }
  });
  
  $(document).ready(function () {
    $(".col-two-video .detail-wrapper .author-info .name-date").each(function () {
        $(this).find("a").clone().appendTo($(this).find(".tooltip"));
      });

  });

})(jQuery);

var timer = 10000;

setTimeout(function() {
// CODE FOR KNOWS THE TEXT TRUNCATED OR NOT
function isEllipsisActive(e) {
    return (e.offsetWidth < e.scrollWidth);
}

var elementList = document.querySelectorAll('.we2022 .col-two-video .detail-wrapper .author-info p');
var elementList1 = document.querySelectorAll('.we2022 .col-two-video .detail-wrapper .author-info .name-date .name-tag');

for(var idx=0; idx < elementList.length; idx++) {

    if ( isEllipsisActive(elementList.item(idx)) ) {
        elementList.item(idx).parentNode.classList.add("ellipsis-active");
    }
}

for(var idx1=0; idx1 < elementList1.length; idx1++) {

    if ( isEllipsisActive(elementList1.item(idx1)) ) {
        elementList1.item(idx1).parentNode.classList.add("ellipsis-active");
    }
}
}, timer);
